<template>
  <div id="NoticeDetail">
    <div class="detail">
      <div class="header">
        <span class="content">
          {{ notice.title }}
        </span>
        <span class="date">
          {{ notice.created }}
        </span>
      </div>
      <div class="body">
        <p
          class="content"
          v-html="notice.content"
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
import noticeApi from '@/api/now/noticeApi'

export default {
  name: 'NoticeDetail',
  components: {
  },
  data: function () {
    return {
      notice: {
        title: '',
        created: '',
        content: null,
      }
    }
  },
  computed: {},
  async created() {
    this.$store.commit('ui/headerTitle', '공지사항')
    await this.setNotice(this.$route.params.uuid)
  },
  methods: {
    async setNotice(uuid) {
      let { data } = await noticeApi.getNotice(uuid)
      this.notice = data
    },
  },
}
</script>

<style lang="scss" scoped>
  #NoticeDetail {
    width: 100%;
    max-width: inherit;
    height: calc(100vh - 60px);
    padding-top: 15px;
    background-color: #f6f6f6;
    .detail {
      color: #333333;
      background-color: #ffffff;
      padding-top: 30px;
      padding-left: 25px;
      padding-right: 25px;
      padding-bottom: 50px;
      .header {
        font-size: 18px;
        font-weight: 800;
        .content {
          display: block;
        }
        .date {
          font-size: 13px;
          font-weight: normal;
          line-height: 1.38;
          letter-spacing: normal;
          color: #727d8c;
        }
      }
      .body {
        margin-top: 20px;
        font-size: 16px;
        line-height: 1.5;
        letter-spacing: -0.2px;
      }
    }
  }
</style>
